interface ProgressBarProps {
  /** 1-indexed step the user is currently on. */
  current: number
  /** Total number of steps in the quiz (questions only - intro/result excluded). */
  total: number
}

/**
 * Thin hot-pink progress bar shown at the top of each question screen.
 * Animated via CSS transition on the width.
 */
export function ProgressBar({ current, total }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, (current / total) * 100))
  return (
    <div
      className="fq-progress"
      role="progressbar"
      aria-valuenow={current}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={`Question ${current} of ${total}`}
    >
      <div className="fq-progress-fill" style={{ width: `${pct}%` }} />
    </div>
  )
}
